exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-background-modal[data-v-230d69f7] .el-dialog__body{padding:24px 32px 0 32px}.modal-title[data-v-230d69f7]{font-size:22px;font-weight:700}.modal-content[data-v-230d69f7]{font-size:16px;margin-bottom:24px;text-align:left}.modal-images[data-v-230d69f7]{display:flex;justify-content:center;gap:32px;margin-bottom:16px}.modal-img[data-v-230d69f7]{width:120px;height:120px;object-fit:contain;border:1px solid #eee;background:#fafafa;border-radius:8px}.dialog-footer[data-v-230d69f7]{text-align:center}", ""]);

// exports
